var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPasswordShow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.903,
    height: 12.807,
    viewBox: "0 0 24.903 12.807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8a8a8a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4286.804 -368.313)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.9,1.334,3.209,6.4,9.9,11.473h7.108L23.694,6.4l-6.689-5.07H9.9M9.449,0h8L25.9,6.4l-8.449,6.4h-8L1,6.4Z",
    transform: "translate(4285.804 368.313)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.668,0,5.336,2.668,2.668,5.336,0,2.668Z",
    transform: "translate(4296.762 372.137)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPasswordShow);
export default __webpack_public_path__ + "static/media/ic_password_show.b396b9287e2cfd9f9431b9bccbb706dd.svg";
export { ForwardRef as ReactComponent };